import { gql } from '@apollo/client';

export const GET_VENDOR_BY_ID = gql`
  query GetVendor($id: ID!) {
    getVendor(id: $id) {
      createdBy
      email
      firstName
      lastName
      paperWorkFinished
      phone
      vendorId
      vendorName
      projects {
        connected
        createdBy
        firstName
        id
        lastName
        mqttEndpoint
        name
        status
        type
        vendorProjectOwnerEmail
        vendorProjectOwnerId
        certificate {
          expirationTime {
            notAfter
          }
        }
      }
      contactInfo {
        city
        country
        state
        street
        zip
      }
      vendorRepresentatives {
        email
        id
        firstName
        lastName
        roles
      }
    }
  }
`;
